/**
 * Local icons. Every Iconify icon the app uses is bundled in ./bundle.json (built by `npm run icons`) and
 * registered here, so <Icon icon="mdi:close" /> renders on first paint with no request to api.iconify.design.
 *
 * Network loading is switched off: an icon missing from the bundle renders nothing and, in development, logs a
 * warning naming it. Fix by running `npm run icons` after adding a new icon name; `npm run lint:ui` also checks.
 *
 * Imported once from pages/_app.tsx.
 */
import { addCollection, _api } from "@iconify/react";
import type { IconifyJSON } from "@iconify/react";
import bundle from "./bundle.json";
// Brand marks Iconify does not have (Polymarket, Kalshi, Google Trends, Google Flights), taken from each site's own
// icon files and kept here by hand; `npm run icons` leaves this file alone.
import brands from "./brands.json";

for (const collection of (bundle as unknown as { collections: IconifyJSON[] }).collections) addCollection(collection);
addCollection(brands as unknown as IconifyJSON);

_api.setFetch(((input: RequestInfo | URL) => {
  if (process.env.NODE_ENV !== "production") {
    console.warn(`[icons] Not bundled: ${String(input)}. Run \`npm run icons\` to add it.`);
  }
  return Promise.reject(new Error("Icons are bundled locally"));
}) as typeof fetch);
